// extracted by mini-css-extract-plugin
module.exports = {"checked":"CardWrapHighlight-module__checked___33-XC","notChecked":"CardWrapHighlight-module__notChecked___VrStb"};